
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ReportPurTaxDialog extends Serenity.EntityDialog<ReportPurTaxRow, any> {
        protected getFormKey() { return ReportPurTaxForm.formKey; }
        protected getIdProperty() { return ReportPurTaxRow.idProperty; }
        protected getLocalTextPrefix() { return ReportPurTaxRow.localTextPrefix; }
        protected getNameProperty() { return ReportPurTaxRow.nameProperty; }
        protected getService() { return ReportPurTaxService.baseUrl; }
        protected getDeletePermission() { return ReportPurTaxRow.deletePermission; }
        protected getInsertPermission() { return ReportPurTaxRow.insertPermission; }
        protected getUpdatePermission() { return ReportPurTaxRow.updatePermission; }

        protected form = new ReportPurTaxForm(this.idPrefix);

    }
}